import React from 'react';
import { Helmet } from 'react-helmet-async';

import email from '../Cv/img/email.svg';
import address from '../Cv/img/address.svg';
import web from '../Cv/img/web.svg';
import linkedin from '../Cv/img/linkedin.svg';
import instagram from '../Cv/img/instagram.svg';
import github from '../Cv/img/github.svg';
import gitlab from '../Cv/img/gitlab.svg';

const Contact = () => {
  const handleGitlabInfoClick = () => {
    window.alert(
      'GitLab is used for Bosch work and cannot be displayed publicly.',
    );
  };

  return (
    <>
      <Helmet>
        <title>Kontakt | Slávka Vavřinová</title>
        <meta
          name="description"
          content="Kontaktujte Slávku Vavřinovou – frontend developer a Czechitas lektorka. Napište e-mail nebo vyplňte kontaktní formulář."
        />
        <link rel="canonical" href="https://www.slavkavav.cz/contact" />
      </Helmet>{' '}
      <div className="main">
        <h2>Contact</h2>
        <div className="center contact__socialIcons--center">
          <div className="contact__row">
            <a className="link" href="mailto:slavka.vav@gmail.com">
              <img className="contact__icon" src={email} alt="Email icon" />
              slavka.vav@gmail.com
            </a>
          </div>
          <div className="contact__row">
            <a className="link" href="https://slavkavav.cz/">
              <img className="contact__icon" src={web} alt="Website logo" />
              https://slavkavav.cz/
            </a>
          </div>
          <div className="contact__row">
            <img className="contact__icon" src={address} alt="Address icon" />{' '}
            <p>České Budějovice</p>
          </div>
        </div>
        <p className="contact__question">Have something on your mind?</p>
        <p className="center">
          Want to talk about collaboration? You can find me on{' '}
          <a
            className="link"
            href="https://www.linkedin.com/in/stanislava-vav%C5%99inov%C3%A1-b325b6204/"
            rel="noreferrer"
          >
            LinkedIn
          </a>
          ,{' '}
          <a
            className="link"
            href="https://www.instagram.com/slavkavavrinova/"
            target="_blank"
            rel="noreferrer"
          >
            Instagram
          </a>{' '}
          or send me an{' '}
          <a className="link" href="mailto:slavka.vav@gmail.com">
            email
          </a>
          {'.'}
          {/*or leave a message:*/}
        </p>

        {/*<ContactForm />*/}

        <div className="contact__socialIcons">
          <a
            href="https://www.linkedin.com/in/stanislava-vav%C5%99inov%C3%A1-b325b6204/"
            target="_blanc"
          >
            <img className="contact__icon" src={linkedin} alt="LinkedIn logo" />
          </a>
          <a href="https://www.instagram.com/slavkavavrinova/" target="_blanc">
            <img
              className="contact__icon"
              src={instagram}
              alt="Instagram logo"
            />
          </a>
          <a href="https://github.com/SlavkaVavrinova" target="_blanc">
            <img className="contact__icon" src={github} alt="GitHub logo" />
          </a>
          <button
            type="button"
            onClick={handleGitlabInfoClick}
            title="I work with GitLab at Robert Bosch, spol. s r. o. The repositories cannot be displayed publicly."
            aria-label="I work with GitLab at Robert Bosch, spol. s r. o. The repositories cannot be displayed publicly."
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
            }}
          >
            <img className="contact__icon" src={gitlab} alt="GitLab logo" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Contact;
